/* eslint-disable quote-props */
import React from 'react';
// eslint-disable-next-line
import { useLocation } from '@reach/router';
import triggerInvoca from '../invoca/trigger-invoca';

// TODO: Remove this context - while keeping the number map for now

export enum DniBrand {
    INVOCA = 'INVOCA',
}

interface DniProviderReturnable {
    provider: DniBrand,
    numberMap: Record<string, string>
}

const DniContext = React.createContext(null as unknown as DniProviderReturnable);

const DniProvider = ({ children }: { children: React.ReactNode }): JSX.Element => {
    const { pathname } = useLocation();
    const provider = DniBrand.INVOCA;

    React.useEffect(() => {
        if (provider === DniBrand.INVOCA) triggerInvoca();
    }, [provider, pathname]);

    const value = React.useMemo(() => ({
        provider,
        numberMap: {},
    }), [provider]);

    return (
        <DniContext.Provider value={value}>
            {children}
        </DniContext.Provider>
    );
};

export const useDniProvider = (): DniProviderReturnable => {
    const ctx = React.useContext(DniContext);
    if (!ctx) {
        throw new Error('No DNI Context has been provided.');
    }
    return ctx;
};

export default DniProvider;
